<template>
  <div>
    <Form ref="sampleInfo" :model="sampleInfo" :label-width="140" :rules="ruleSample">
      <FormItem :label="$t('editCase.sampleNumber')" prop="sample_code" class="case-detail-form-item">
        <Input v-model="sampleInfo.sample_code" maxlength="20"></Input>
      </FormItem>
      <FormItem :label="$t('addNewCase.caseInfo.sampleType')" class="case-detail-form-item">
        <Input v-model="sampleInfo.sample_types" maxlength="20"></Input>
      </FormItem>
      <FormItem :label="$t('editCase.sampleDescription')" class="case-detail-form-item">
        <Input v-model="sampleInfo.sample_desc" maxlength="20"></Input>
      </FormItem>
    </Form>
    <div slot="footer" style="text-align: right;">
      <Button type="primary" size="large" @click.native="newSamFormValidate('sampleInfo')">{{$t('editCase.save')}}</Button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['fxffList', 'caseId', 'rslxList'],
  data () {
    return {
      sampleInfo: {
        sample_code: ''
      },
      ruleSample: {
        sample_code: [
          { required: true, message: this.$t('editCase.slideNumberTip'), trigger: 'blur' }
        ]
      }
    }
  },
  beforeMount () {
    this.$vue = this
  },
  methods: {
    newSamFormValidate (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.saveNewSample()
        } else {
          this.warning()
        }
      })
    },
    async saveNewSample () {
      let params = new URLSearchParams()
      params.append('case_id', this.caseId)
      params.append('sampleInfo', JSON.stringify(this.sampleInfo))
      let suc = await this.$http.post(this.$vue.getData('GET_ADD_CASE_SAMPLE_URL'), params)
      if (suc.data.result === '1') {
        this.$emit('reLoadSampleSlideList')
        this.success()
      } else {
        this.warning()
      }
    },
    // 保存成功消息提醒
    success () {
      this.$Notice.success({
        title: this.$t('caseList.messageNotification'),
        desc: this.$t('editCase.addSampleSuccessfully')
      })
    },
    // 保存失败消息提醒
    warning () {
      this.$Notice.error({
        title: this.$t('caseList.messageNotification'),
        desc: this.$t('editCase.failedToAddSample')
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/case/caseManager/caseDetail/AddNewSample.vue